import React, { Component } from "react";
import "./css/ActiveProjectsCounter.css";

class ActiveProjectsCounter extends Component {
  render() {
    const { count = 12 } = this.props;

    return (
      <div className="apc-wrapper">
        <div className="apc-card">
          <div className="apc-label">Active Projekte</div>
          <div className="apc-number">{count}</div>
          <div className="apc-divider"></div>
        </div>
      </div>
    );
  }
}

export default ActiveProjectsCounter;